import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header';
import styles from './index.css';
import addEventListener from '@ifeng-fe/three_terminal/es/base/base/addEventListener.js';
import {
    TimeLine,
    Category,
    ViewPoint,
    BottomComment,
    PicAd,
    HeaderBanner,
    CallUpTip,
    SubTopics,
} from './topicComponents';
import { Quan } from './topicComponents/quan/quan';
import { Copyright } from '@ifeng-fe/three_terminal/es/mobile/copyright/index.js';
import { PageBottomBrand } from '@ifeng-fe/three_terminal/es/mobile/pageBottomBrand/index.js';
import { CallupHead } from '@ifeng-fe/three_terminal/es/mobile/callupHead/index.js';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/index.js';
import { SimpleGuideLayer } from '@ifeng-fe/three_terminal/es/mobile/simpleGuideLayer/index.js';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Chip from 'Chip';
import { h5PageCount } from '@ifeng-fe/three_terminal/es/utils/h5PageCount.js';
import { addBackGuide } from '@ifeng-fe/three_terminal/es/utils/handlePageBack.js';
import { handleTopicPreviewData } from '../../../services/utils';
import { nativeShare } from '@ifeng-fe/container_content/common/client/utils/nativeShare';
import { getQuanData, getQuanDataForP, getQuanDataList, getTopicData, getQueryString } from '../../../services/api';
import Grounds from '@ifeng-fe/three_terminal/es/base/grounds';
import FixedIcon from '@ifeng-fe/container_content/common/client/fixedIcon';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
// import { getLikeCountForQuan } from './topicComponents/utils/api';
import TimelineH5 from './topicComponents/timeline/timeline';

const inApp = typeof window !== 'undefined' && window.grounds;

const topicType = {
    review: errorBoundary(TimeLine),
    column: errorBoundary(Category),
    point: errorBoundary(ViewPoint),
    comment: errorBoundary(BottomComment),
    discuss: errorBoundary(Quan),
    timeline: errorBoundary(TimelineH5),
};

const SwipeItems = errorBoundary(({ docData, activeIndex }) => {
    const result = [];
    const ItemDom = (item) => (
        <div
            className={`${styles.swipe_header_item} ${
                parseInt(activeIndex) === item.moduleIndex ? styles.swipe_header_item_activeIndex : null
            }`}
            key={item.moduleIndex}
            data-index={item.moduleIndex}>
            {item.title || item.columnName}
        </div>
    );

    docData.modules.forEach((item) => {
        if (!item.display || (inApp && item.type === 'comment')) return;

        if (item.type !== 'column' && (item.data.length || item.type === 'comment')) {
            result.push(ItemDom(item));
        } else {
            item.data.forEach((subItem) => {
                result.push(ItemDom(subItem));
            });
        }
    });

    return result;
});

class TopicBlocks extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        content: PropTypes.object,
        renderAdBlock: PropTypes.func,
        isShare: PropTypes.bool,
        topicData: PropTypes.object,
        handleCallUp: PropTypes.func,
    };

    render() {
        const { docData, content, renderAdBlock, isShare, topicData, handleCallUp } = this.props;
        const result = [];
        let selfShowModuleNum = 0;

        if (docData.modules) {
            docData.modules.forEach((item, index) => {
                if (item.type === 'comment' && item.data[0] && item.data[0].allowComment === -1) return;

                if ((item.data.length > 0 || item.type === 'comment') && item.display && item.type !== 'slide') {
                    const TopicBlock = topicType[item.type];
                    const moduleData = Object.assign(
                        {
                            isShare,
                            topicData,
                            base62Id: docData.base62Id,
                        },
                        item,
                    );

                    ++selfShowModuleNum;

                    if (isShare) {
                        renderAdBlock({ selfShowModuleNum, docData, moduleType: item.type, result });
                    }

                    if (inApp && item.type === 'comment') return;

                    result.push(
                        <div
                            key={index}
                            onClick={(e) => {
                                if (item.type !== 'comment') handleCallUp(e);
                            }}>
                            <a name={`${moduleData.type}`} className={styles.ancher} />
                            {moduleData.moduleIndex ? (
                                <a
                                    data-type="moduleIndex"
                                    name={`moduleIndex_${moduleData.moduleIndex}`}
                                    className={styles.ancher}
                                />
                            ) : null}
                            <TopicBlock content={moduleData} allData={content} />
                        </div>,
                    );
                }
            });
        }

        return result;
    }
}

const AppShareInfo = errorBoundary(({ docData }) => {
    return inApp ? (
        <div style={{ display: 'none' }}>
            <div id="ifeng_share_url" style={{ display: 'none' }}>
                {`https://news.ifeng.com/c/s/${docData.base62Id}`}
            </div>
            <div id="ifeng_share_title" style={{ display: 'none' }}>
                {docData.shareTitle}
            </div>
            <div id="ifeng_share_thumbnail" style={{ display: 'none' }}>
                {docData.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg'}
            </div>
            <div id="ifeng_share_description" style={{ display: 'none' }}>
                {docData.introduction}
            </div>
        </div>
    ) : null;
});

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.content = React.createRef();
        this.swipeMenu = React.createRef();
        this.isAllowSwipeMenuChangeByScroll = true;
        this.isSimulateClickByScroll = false;
        this.vivoModuleSta = {}; // vivo 模块曝光统计

        this.clickedItem = null; // 断流点击
    }

    state = {
        docData: handleTopicPreviewData(
            this.props.content.docData,
            this.props.content.isShare,
            this.props.content.isVivo,
        ),
        topicData: {},
        isShare: this.props.content.isShare, // 是否是分享页
        isVivo: this.props.content.isVivo,
        adShow: {
            threeImagesAd: true,
            bigImageAd: true,
            bannerAd: true,
        },
        moduleIndex: 1,
        scrollDirection: this.props.content.isVivo || inApp ? 'down' : 'up',
        showSwipeHead: false,
        showCallUpTip: false,
    };

    sendVivoSta = (index) => {
        if (!this.state.isVivo || this.vivoModuleSta[index]) return;

        this.vivoModuleSta[index] = true;

        h5PageCount([
            {
                behavior: 'info',
                type: `national_${index}`,
                other: {
                    url: encodeURIComponent(location.href),
                },
            },
        ]);
    };

    bindModuleScrollEvent = () => {
        const { isVivo } = this.state;
        const srcollBox = document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop);
        let beforeScrollTop = srcollBox || 0;
        let stausDown = true;
        let stausUp = true;

        this.sendVivoSta(0);

        window.addEventListener(
            'scroll',
            () => {
                const afterScrollTop =
                    document.body.scrollTop || (document.documentElement && document.documentElement.scrollTop) || 0;
                const delta = afterScrollTop && afterScrollTop - beforeScrollTop;

                const anchers = document.querySelectorAll('a[data-type="moduleIndex"]');
                let currentModule = 0;
                let target = {};

                anchers.forEach((ancher) => {
                    if (afterScrollTop - this.content.current.offsetTop - ancher.offsetTop > -360) {
                        target = ancher;
                        currentModule = target.attributes.name.value.split('_')[1];
                    }

                    this.sendVivoSta(currentModule);
                });

                if (
                    this.swipeMenu.current &&
                    this.state.moduleIndex !== currentModule &&
                    this.isAllowSwipeMenuChangeByScroll
                ) {
                    this.swipeMenu.current.childNodes.forEach((child) => {
                        if (child.attributes['data-index'].value === currentModule) {
                            this.isSimulateClickByScroll = true;
                            setTimeout(() => {
                                child.click();
                            }, 0);
                        }
                    });
                }

                if (afterScrollTop - this.content.current.offsetTop > -80) {
                    this.setState({
                        showSwipeHead: true,
                    });
                } else {
                    this.setState({
                        showSwipeHead: false,
                    });
                }

                if (delta && delta > 0 && stausUp) {
                    stausDown = true;
                    stausUp = false;

                    this.setState({
                        scrollDirection: 'down',
                    });
                    // console.log('向下');
                } else if (delta && delta < 0 && stausDown && !inApp) {
                    stausUp = true;
                    stausDown = false;

                    if (!isVivo) {
                        this.setState({
                            scrollDirection: 'up',
                        });
                    }
                    // console.log('向上');
                }

                beforeScrollTop = afterScrollTop;

                return false;
            },
            false,
        );
    };

    async componentDidMount() {
        const { docData, isShare, isVivo } = this.state;

        if (location.href.includes('/c/')) {
            this.unUpdate = addEventListener(window, 'message', this.handleUpdate);
            window.parent.postMessage('ready', '*');
        }

        if (!isVivo) {
            this.getFooterSlideData({
                title: docData.title,
                id: docData.title,
                from: 'share_relate_foot_rjsy',
                staId: docData.base62Id,
                isShare,
                isVideoShare: docData.isVideoShare,
            });

            if (!inApp) addBackGuide('https://ishare.ifeng.com/hotNewsRank');
        }

        if (docData.talkId) {
            getTopicData(docData.talkId).then(({ data }) => {
                this.setState({
                    topicData: data.body,
                });
            });
        }

        if (isShare) {
            if (inApp) {
                Grounds.pageStat({
                    type: 'topic',
                    id: `special_${docData.base62Id}`,
                });
            } else if (getQueryString('from') === 'huaweiAds') {
                h5PageCount([
                    {
                        datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
                        behavior: 'page',
                        type: 'other',
                        other: {
                            id: 'hwadszt',
                            ref: encodeURIComponent(document.referrer),
                            url: encodeURIComponent(location.href),
                        },
                    },
                ]);
            } else {
                h5PageCount([
                    {
                        datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
                        behavior: 'page',
                        type: 'topic',
                        other: {
                            id: `special_${docData.base62Id}`,
                            ref: encodeURIComponent(document.referrer),
                            url: encodeURIComponent(location.href),
                        },
                    },
                ]);
            }

            this.bindModuleScrollEvent();
        }

        if (isVivo) this.bindModuleScrollEvent();
        // const quanData = await getQuanDataList(6839530843489177600);

        // console.log(quanData);
        this.setState({
            qqShareCofig: {
                title: `${docData.shareTitle}`,
                appType: docData.isVideoShare ? 'videoApp' : 'newsApp',
                img: docData.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
                desc: docData.introduction,
            },
        });
    }

    componentWillUnmount() {
        this.unUpdate();
    }

    handleUpdate = async (e) => {
        if (e.data === 'isAxure') {
            return;
        }

        if (e.data && e.data.title !== undefined) {
            try {
                let docData = handleTopicPreviewData(e.data, this.state.isShare);
                // TODO :  docData 整理

                docData.modules = await getQuanDataForP(docData.modules);
                this.setState({
                    docData,
                });
            } catch (e) {
                console.error(e);
            }
        }
    };

    handleWxShareClick = (type) => {
        const { docData } = this.props.content;
        const config = {
            url: docData.pcUrl || '',
            title: docData.title || '',
            desc: docData.summary || '',
            img: docData.bannerImg || '',
            img_title: '',
            from: docData.source || '',
            summary: docData.summary || '',
        };
        const from = window.location.search.indexOf('?ch=qd_hw_fyp1') !== -1;

        nativeShare(config, from, type);
    };

    handleCloseAd = (type) => {
        const adShow = Object.assign({}, this.state.adShow);

        adShow[type] = false;
        this.setState({
            adShow,
        });
    };

    renderAdBlock = ({ docData, selfShowModuleNum, moduleType, result }) => {
        if (moduleType === 'comment') {
            result.push(
                <PicAd
                    content={docData.adData}
                    close={this.handleCloseAd}
                    adShow={this.state.adShow}
                    adType={'threeImagesAd'}
                    key={'threeImagesAd'}
                />,
            );
        }

        if (
            selfShowModuleNum === 3 &&
            ((docData.showModuleNum === 3 && !docData.showCommentModule) || docData.showModuleNum > 3)
        ) {
            result.push(
                <PicAd
                    content={docData.adData}
                    close={this.handleCloseAd}
                    adShow={this.state.adShow}
                    adType={'bigImageAd'}
                    key={'bigImageAd'}
                />,
            );
        }
    };

    // 分享页头部、底部配置
    getFooterSlideData = (config) => {
        const { content } = this.props;
        const wxLaunch = (content.popup && content.popup.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const wxLaunchType = wxLaunchConfig.wxLaunchType;
        const wxLaunchSwitch = wxLaunchConfig.wxLaunchSwitch;
        const insertSlideArr = [];
        const slideNum = 4;
        const FROMURL = getQueryString('from', '');

        for (let i = 0; i < slideNum; i++) {
            insertSlideArr.push({
                isVideoShare: config.isVideoShare,
                kind: config.isShare ? 'share01' : 'df_sf01',
                clickCount: {
                    behavior: 'action',
                    type: 'downopen',
                    kind: 'topic',
                    other: {
                        to: true,
                        ref: `special_ucms_${config.staId}`,
                        kind: 'topic',
                        url: encodeURIComponent(location.href),
                        plat: 'napp',
                        downurl: `https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=${
                            config.isShare ? 'CK1354725251042' : 'CK1429035767411'
                        }`,
                    },
                },
                downloads: config.isVideoShare
                    ? {}
                    : {
                          download: `https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=${
                              config.isShare ? 'CK1354725251042' : 'CK1429035767411'
                          }`,
                          downloadAd: `https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=${
                              config.isShare ? '7641' : '7675'
                          }`,
                      },
                wxLaunchType,
                wxLaunchSwitch,
            });
        }
        const callAppConfig = {
            docType: 'topic3',
            kind: FROMURL === 'huaweiAds' ? 'brand_hwads15' : 'share52202',
            noKindFrom: FROMURL === 'huaweiAds' ? 1 : 0,
            pid: config.staId,
            download:
                FROMURL === 'huaweiAds'
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902436240352256'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd:
                FROMURL === 'huaweiAds'
                    ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9116'
                    : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        this.setState({
            callAppConfig,
            headerConfig: config.isShare
                ? {
                      isVideoShare: config.isVideoShare,
                      pageInfo: {
                          type: 'topic3',
                          kind: 'topic',
                          url: location.href,
                          id: `ucms_${config.staId}`,
                          position: 1,
                          downloads: config.isVideoShare
                              ? {}
                              : {
                                    download:
                                        FROMURL === 'huaweiAds'
                                            ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902436240352256'
                                            : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                                    downloadAd:
                                        FROMURL === 'huaweiAds'
                                            ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9116'
                                            : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                                },
                          noKindFrom: FROMURL === 'huaweiAds' ? 1 : 0,
                      },
                      topClickInfo: {
                          behavior: 'action',
                          type: 'upopen',
                          ref: `special_ucms_${config.staId}`,
                          kind: 'topic',
                          callupKind: FROMURL === 'huaweiAds' ? 'brand_hwads15' : 'share52201',
                      },
                      fixClickInfo: {
                          behavior: 'action',
                          type: 'grgxfc',
                          ref: `special_ucms_${config.staId}`,
                          kind: 'topic',
                          callupKind: FROMURL === 'huaweiAds' ? 'brand_hwads15' : 'share52201',
                      },
                      hotKeyword: [
                          '这条最新发布的内容，80%的网友都在看',
                          '热热热！这条精彩内容，你的朋友们都在看',
                          '过去24小时发生了这些好玩的事，点击查看',
                          '全网最热新闻出炉，这些事儿你都知道吗？',
                          '想不到！今天最火爆的新闻居然是……',
                          '这条重磅新闻刚刚发布！快来查看',
                          '过去的24小时你错过了这些重要新闻……',
                          '今天这条消息，90%的人都不知道！',
                      ],
                      wxLaunchType,
                      wxLaunchSwitch,
                  }
                : undefined,
        });
    };

    adjustSwipeItem = (c, p) => {
        const itemLeft = c.offsetLeft + c.clientWidth - p.scrollLeft - p.clientWidth;

        if (itemLeft > 0) {
            p.scrollLeft = c.offsetLeft - p.clientWidth + c.clientWidth + p.clientWidth / 2;
        } else if (c.offsetLeft < p.scrollLeft) {
            p.scrollLeft = c.offsetLeft - p.clientWidth / 2;
        }
    };

    changeSwipeItem = (e) => {
        this.isAllowSwipeMenuChangeByScroll = false;

        const moduleIndex = e.target.attributes['data-index'].value;
        const anchers = document.querySelectorAll('a[data-type="moduleIndex"]');
        const preModuleFix = this.state.moduleIndex > moduleIndex ? -45 : 0;

        anchers.forEach((ancher) => {
            const index = ancher.attributes['name'].value.split('_')[1];

            if (index === moduleIndex && !this.isSimulateClickByScroll) {
                window.scroll(0, ancher.offsetTop + this.content.current.offsetTop + preModuleFix);
            }
        });

        this.adjustSwipeItem(e.target, e.currentTarget);

        this.setState(
            {
                moduleIndex,
            },
            () => {
                setTimeout(() => {
                    this.isAllowSwipeMenuChangeByScroll = true;
                    this.isSimulateClickByScroll = false;
                }, 500);
            },
        );
    };

    toggleCallUpTip = (type) => {
        this.setState(
            {
                showCallUpTip: type,
            },
            () => {
                const popup = this.props.content.popup.topicPopup;

                if (!type && popup !== '2') this.clickedItem = null;

                if (popup === '2' && type === false) {
                    this.clickedItem.click();
                }
            },
        );
    };

    staticHandler = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content } = this.props;
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';
        const downloadVal = content.isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035725136',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
              };

        if (isCallApp) {
            callApp({
                client,
                docType: 'topic3',
                pid: content.docData && content.docData.base62Id,
                kind: 'inter|other_in_sf01',
                noKindFrom: 1,
                download: downloadVal.download,
                downloadAd: downloadVal.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    handleCallUp = (e) => {
        const { isShare, isVivo } = this.state;
        const { content } = this.props;
        const { topicPopup } = this.props.content.popup;

        if (inApp || isVivo || isShare || topicPopup === '1' || this.clickedItem || content.docData.isVideoShare) {
            return false;
        }

        this.clickedItem = e.target;

        e.preventDefault();
        this.toggleCallUpTip(true);

        return true;
    };

    render() {
        const {
            docData,
            isShare,
            isVivo,
            topicData,
            headerConfig,
            qqShareCofig,
            scrollDirection,
            showSwipeHead,
            showCallUpTip,
        } = this.state;
        const { content } = this.props;
        const { channel, downloads, popup, pageBottomPic } = content;
        const bannerAdUrl =
            docData.adData &&
            docData.adData.bannerAd &&
            docData.adData.bannerAd.data &&
            docData.adData.bannerAd.data.url;
        const bannerAdImg =
            docData.adData &&
            docData.adData.bannerAd &&
            docData.adData.bannerAd.data &&
            docData.adData.bannerAd.data.img;
        const showSlideCard = docData.slideDisplay && docData.slideData && docData.slideData.data.length;
        const isBlankTop = !bannerAdImg && !docData.bannerImg;
        const popupType = (popup && popup.topicPopup) || '1';
        const unfoldTextInfo = (popup && popup.topicPopupLayer) || {};
        const wxLaunch = (content.popup && content.popup.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const isVideoShare = content.isVideoShare;
        const schemeLink =
            wxLaunchConfig.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'topic3',
                      pid: content.docData && content.docData.base62Id,
                  })
                : getSchemeLink({
                      docType: 'topic3',
                      pid: content.docData && content.docData.base62Id,
                      kind: 'inter|other_in_sf01',
                      noKindFrom: 1,
                  });
        const FROMURL = getQueryString('from', '');

        const brandPic = isVideoShare ? pageBottomPic.videoBrandPic : pageBottomPic.newBrandPic;
        const callAppConfig = brandPic
            ? {
                  docType: 'custom',
                  kind: FROMURL === 'huaweiAds' ? 'brand_hwads15' : 'share52202',
                  noKindFrom: FROMURL === 'huaweiAds' ? 1 : 0,
                  pid:
                      (pageBottomPic.schemeUrl && `${pageBottomPic.schemeUrl}&timeStamp=${new Date().getTime()}`) || '',
                  download:
                      FROMURL === 'huaweiAds'
                          ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902436240352256'
                          : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1475599819841',
                  downloadAd:
                      FROMURL === 'huaweiAds'
                          ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9116'
                          : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8826',
              }
            : {
                  docType: 'topic3',
                  kind: FROMURL === 'huaweiAds' ? 'brand_hwads15' : 'share52202',
                  noKindFrom: FROMURL === 'huaweiAds' ? 1 : 0,
                  pid: content.docData.base62Id,
                  download:
                      FROMURL === 'huaweiAds'
                          ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210902436240352256'
                          : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd:
                      FROMURL === 'huaweiAds'
                          ? 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9116'
                          : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };
        const actionConfig = brandPic
            ? [
                  {
                      behavior: 'action',
                      type: 'openapp_phtv',
                      other: {
                          ref: `ucms_${content.docData.base62Id}`,
                          kind: 'topic',
                      },
                  },
              ]
            : [
                  {
                      behavior: 'action',
                      type: 'downopen',
                      other: {
                          ref: `ucms_${content.docData.base62Id}`,
                          kind: 'topic',
                          url: encodeURIComponent(typeof window == 'object' ? window.location.href : ''),
                      },
                  },
              ];
        // docData.title = '中美贸易战：可以停止吗？'
        // docData.introduction = '世界上两个最大的贸易国家本周宣布决定关税计划，但有迹象表明仍可以避免全面的贸易战。'
        // docData.introDisplay = 1

        console.log(wxLaunchConfig, popup, 'wxLaunchConfig')

        return (
            <div
                className={`${styles.container} ${isShare ? styles.containerShare : null} ${
                    isVivo ? styles.containerVivo : null
                }`}>
                {channel.title && !isShare && !isVivo && !inApp ? (
                    <Header content={{ channel, downloads, docData }} />
                ) : (
                    ''
                )}
                {headerConfig && !inApp && (
                    <div className={styles.share_header}>
                        <CallupHead
                            content={headerConfig}
                            closeCallback={() => {
                                this.setState({
                                    scrollDirection: 'down',
                                });
                            }}
                        />
                    </div>
                )}
                <div
                    ref={this.swipeMenu}
                    onClick={(e) => this.changeSwipeItem(e)}
                    style={{
                        display: showSwipeHead ? 'block' : 'none',
                    }}
                    className={`${styles.swipe_header} ${scrollDirection === 'up' ? styles.swipe_header_fix : null}`}>
                    <SwipeItems docData={docData} activeIndex={this.state.moduleIndex} />
                </div>
                <a name="top" />
                <Chip id="170111" type="struct" title="手凤专题是否断流" groupName="手凤专题是否断流">
                    <div />
                </Chip>
                <HeaderBanner
                    content={{ bannerAdUrl, isShare, docData, isVivo, bannerAdImg }}
                    handleCallUp={this.handleCallUp}
                />
                <div
                    className={`${styles.content} ${showSlideCard && !isBlankTop ? styles.content_with_slider : null}`}
                    ref={this.content}>
                    <SubTopics content={docData} handleCallUp={this.handleCallUp} isShare={isShare} isVivo={isVivo} />
                    <TopicBlocks
                        docData={docData}
                        content={content}
                        renderAdBlock={this.renderAdBlock}
                        isShare={isShare}
                        topicData={topicData}
                        handleCallUp={this.handleCallUp}
                    />
                </div>
                {!isShare && !isVivo && <Copyright />}
                {callAppConfig && !inApp && (
                    <div className={styles.bottomSlide}>
                        <PageBottomBrand
                            brandPic={brandPic}
                            isVideoShare={isVideoShare}
                            callAppConfig={callAppConfig}
                            actionConfig={actionConfig}
                            wxLaunchConfig={wxLaunchConfig}
                        />
                    </div>
                )}
                {qqShareCofig && <QQShare content={qqShareCofig} />}
                {!isShare && !isVivo && (
                    <SimpleGuideLayer
                        isShowGuideLayer={showCallUpTip}
                        unfoldType={popupType}
                        unfoldTextInfo={unfoldTextInfo}
                        closeGuideFn={() => this.toggleCallUpTip(false)}
                        gotoClientFn={this.staticHandler}
                        wxLaunchType={wxLaunchConfig.wxLaunchType}
                        wxLaunchSwitch={wxLaunchConfig.wxLaunchSwitch}
                        schemeLink={schemeLink}
                    />
                )}
                {isVivo && typeof location !== 'undefined' && /vivoback/.test(location.search) ? (
                    <div
                        className={styles.goback}
                        onClick={() => {
                            history.back();
                        }}>
                        返回
                    </div>
                ) : null}
                <ChipEdit transform={transform} />
                <AppShareInfo docData={docData} />
                {isShare ? (
                    <FixedIcon
                        type={content.fixedIcon.topic}
                        link={content.fixedIcon.link}
                        image={content.fixedIcon.image}
                        clientLink={content.fixedIcon.clientLink}
                        pageType="artcile"
                        base62Id={docData.base62Id}
                    />
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(Layout);
